export default __webpack_public_path__ + "static/media/BarcodeWhite.53f0cadd.svg";